module.exports = __webpack_public_path__ + "static/media/custom-slide-img3.d23a1390.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/custom-slide-img3.png
// module id = 1050
// module chunks = 0